<main class="w-full">
	@if (isLabeled) {
		<div class="flex flex-row flex-wrap w-full overflow-x-hidden">
			<div class="pr-[16px] w-[15%]">
				<lbca-entity-fields
					[forceType]="'SELECT_ONE'"
					[field]="uf"
					[label]="uf.label"
					[error]="uf.error"
					[disabled]="uf.disabled || isDisabled"
					[require]="uf.required"
					[value]="uf.value"
					[cardData]="cardInfo"
					(changeLabelValue)="changeValue(uf, $event)"
				></lbca-entity-fields>
			</div>
			<div class="pl-[16px] pr-[16px] w-[25%]">
				<lbca-input-text
					[label]="registro.label"
					[require]="registro.require"
					[disabled]="registro.disabled || isDisabled"
					[value]="registro.value"
					(changeValue)="changeValue(registro, $event)"
				></lbca-input-text>
			</div>
			<div class="pl-[16px] pr-[16px] w-[15%]">
				<lbca-entity-fields
					[forceType]="'SELECT_ONE'"
					[field]="digito"
					[label]="digito.label"
					[error]="digito.error"
					[disabled]="digito.disabled || isDisabled"
					[require]="digito.required"
					[value]="digito.value"
					[cardData]="cardInfo"
					(changeLabelValue)="changeValue(digito, $event)"
				></lbca-entity-fields>
			</div>
		</div>
	}

	@if (!isLabeled) {
		<div class="flex flex-row flex-wrap w-full overflow-x-hidden">
			<lbca-input-text
				[label]="'OAB'"
				[disabled]="true"
				[labeled]="isLabeled"
				[value]="oab"
				(changeValue)="changeValue(registro, $event)"
			></lbca-input-text>
		</div>
	}
</main>
